import React from 'react';
import ComingSoon from '../components/ComingSoon';

export default function AdvancedAnalytics() {
  return (
    <ComingSoon
      eyebrow="FLOWQUANT PREMIUM"
      title="Advanced Analytics"
      description="Dive deeper into your trading performance with expanded metrics, behavior trends, and more advanced visual breakdowns designed to sharpen decision-making."
    />
  );
}